import { createContext, useContext, type ReactNode } from 'react';

import { InnerHandler } from '../types/pie-chart.config.js';

const initialValue = {
  innerElement: () => null,
};

export const InnerElementContext = createContext<{
  innerElement: InnerHandler | ReactNode;
}>(initialValue);

export const useChartInnerElement = () => useContext(InnerElementContext);

InnerElementContext['displayName'] = 'InnerElementContext';
